<template>
    <div id="container">
        <top-nav></top-nav>
        <mobile-nav></mobile-nav>
        <section-one></section-one>
        <mobile-two></mobile-two>
        <tab-two></tab-two>
        <section-two></section-two>
        <section-three></section-three>
        <section-four></section-four>
        <section-five></section-five>
        <section-six></section-six>
        <mobile-six></mobile-six>
        <section-seven></section-seven>
        <footer-comp></footer-comp>
    </div>
</template>

<script>
import TopNav from '../components/general/top-nav.vue';
import MobileNav from '../components/general/mobile-nav.vue'
import SectionOne from '../components/landing/section-one.vue'
import MobileTwo from '../components/landing/mobile-two.vue'
import TabTwo from '../components/landing/tab-two.vue'
import SectionTwo from '../components/landing/section-two.vue'
import SectionThree from '../components/landing/section-three.vue'
import SectionFour from '../components/landing/section-four.vue'
import SectionFive from '../components/landing/section-five.vue'
import SectionSix from '../components/landing/section-six.vue'
import MobileSix from '../components/landing/mobile-six.vue'
import SectionSeven from '../components/landing/section-seven.vue'
import FooterComp from '../components/general/footer-comp.vue'
import {useStore} from  'vuex'
import {onMounted} from 'vue'
export default {
    components:{TopNav,MobileNav,SectionOne,SectionTwo,MobileTwo,TabTwo,SectionThree,SectionFour,SectionFive,SectionSix,MobileSix,SectionSeven,FooterComp},
    setup() {
        onMounted(()=>{
            const store = useStore()
            store.commit('setActivePage',1)
        })
        return{}
    },
}
</script>
<style scoped>
@media only screen and (max-width:480px){
    #container{
        width:100vw;
        height: 100vh;
        position: absolute;
        top:0;
        left:0;
        background: #04042D;
        padding-bottom:4vh;
        overflow-y:auto;
        overflow-x:hidden;
        margin:0;
        padding:0;
    }
    #container::-webkit-scrollbar{
        display: none;
    }
}
@media only screen and (min-width:480px) and (max-width:960px){
    #container{
        width:100vw;
        height: 100vh;
        position: absolute;
        top:0;
        left:0;
        background: #04042D;
        padding-bottom:4vh;
        overflow-y:auto;
        overflow-x:hidden;
        margin:0;
        padding:0;
    }
    #container::-webkit-scrollbar{
        display: none;
    }
}
@media only screen and (min-width:961px){
    #container{
        width:100vw;
        height: 100vh;
        position: absolute;
        top:0;
        left:0;
        background: #04042D;
        padding-bottom:4vh;
        overflow-y:auto;
        overflow-x:hidden;
        margin:0;
        padding:0;
    }
    #container::-webkit-scrollbar{
        display: none;
    }
}
</style>